import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import analyticsApi from '../../../../analytics.api';
import {DimensionValue} from '../../../../analytics.types';
import getRemoteDimensionKey from '../../../../utils/getRemoteDimensionKey';
import {CampaignAnalyticsToolName} from '../campaignAnalyticsAgent.enums';

function supportedFilterValuesTool(store: CLStore) {
  const inputSchema = z.object({
    dimension: z.string().describe('The filtering dimension'),
  });

  async function execute({
    input: {dimension},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const {
      campaignPage: {
        campaignTree: {campaign},
        insightsPage: {availableFilters},
      },
    } = store.getState();

    const filterKey = getRemoteDimensionKey<DimensionValue>(availableFilters, dimension);

    if (!filterKey) {
      return toolResult('Sorry, this dimension is not supported');
    }

    const availableFilterValues = await analyticsApi.getOptionalFiltersByDimension(
      filterKey,
      campaign.id,
    );

    return toolResult(JSON.stringify(availableFilterValues));
  }

  return tool({
    name: CampaignAnalyticsToolName.SupportedFilterValues,
    displayName: 'Getting supported options for filter',
    description: 'Retrieves values allowed for a filtering dimension',
    execute,
    inputSchema,
  });
}

export default supportedFilterValuesTool;
